import {Scan} from "@/types/Scan";
import React from "react";
import {useTranslations} from "use-intl";
import {Fab} from "@mui/material";
import {IoCaretForwardCircle} from "react-icons/io5";
import SportsScoreIcon from "@mui/icons-material/SportsScore";
import {useAppStore} from "@/store/AppStore";
import useWalkStatus from "@/utils/hooks/useWalkStatus";

type WalkActionsProps = {
  handleNext: () => void
  qrCode?: false | Scan[]
}

export default function WalkBtns(props: WalkActionsProps) {
  const t = useTranslations("Walk")
  const setScanningAction = useAppStore((state) => state.setScanningAction);
  const setShowAbandon = useAppStore((state) => state.setShowAbandon);

  const {handleNext, qrCode} = props
  const walkStatus = useWalkStatus()

  if (!qrCode) return
  const pid = walkStatus?.paths?.filter((itm) => {
    return itm.current
  }).at(0)?.path_id.toString()
  const currentSegment = walkStatus?.last_user_action?.segment_id

  const filtered = pid && currentSegment ? qrCode.filter((item: Scan) => {
    return String(item.segment_id) === String(currentSegment) && String(item.path_id) === String(pid)
  }) : qrCode

  if (filtered.length === 0 && pid) {
    setShowAbandon(true)
  } else {
    setShowAbandon(false)
  }
  const start = filtered.find((item: Scan) => {
    return item.type == 'start'
  })
  const end = filtered.find((item: Scan) => {
    return item.type == 'end'
  })


  return <>
    {start && <Fab onClick={() => {
      setScanningAction('start')
      handleNext()
    }} variant="extended" color={"success"}>
      <IoCaretForwardCircle style={{marginRight: '0.8rem'}} size={20}/>
      {t('start_segment')}
    </Fab>}
    {end && <Fab onClick={() => {
      setScanningAction('end')
      handleNext()
    }} variant="extended" color={"error"}>
      <SportsScoreIcon sx={{mr: 1}}/>
      {t('end_segment')}
    </Fab>}
    {start && end && <Fab onClick={() => {
      setScanningAction('start-end')
      handleNext()
    }} variant="extended" color={"info"}>
      <IoCaretForwardCircle style={{marginRight: '0.8rem'}} size={20}/>
      <SportsScoreIcon sx={{mr: 1}}/>
      {t('start_end_segment')}
    </Fab>
    }
  </>
}
